module.exports = __webpack_public_path__ + "assets/images/user-clock--emerald.svg?e735c982f6b081cb199bb8df063d42b5";


//////////////////
// WEBPACK FOOTER
// ./_source/images/notifications/user-clock--emerald.svg
// module id = 632
// module chunks = 0